import {Component, EventEmitter, Input, OnInit, OnDestroy, Output} from '@angular/core';
import {HscWebsocket} from '../../hsc-websocket';
import {MessagesService} from '../../../services/messages.service';
import { MSG_TYPE } from '../../../enum/message.enum';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import {NzMessageService} from 'ng-zorro-antd';
import { Lightbox } from '../../../components/lightbox';

@Component({
  selector: 'app-hsc-modal',
  templateUrl: './hsc-modal.component.html',
  styleUrls: ['./hsc-modal.component.scss'],
})
export class HscModalComponent implements OnInit, OnDestroy {
  hscWebsocket: any;
  _visible = false;
  buttonDisable = false;
  downloadModalVisible = false;
  messageType = MSG_TYPE;
  subscription = new Subscription();
  isDeskew = false;
  isSubCamera = false;
  _fileTypeList: any[] = [];

  @Input()
  set settingVisible(v) {
    this._visible = v;
  }

  get settingVisible() {
    return this._visible;
  }

  @Input()
  set fileTypeList(v) {
    this._fileTypeList = v;
  }
  get fileTypeList() {
    return this._fileTypeList;
  }
  @Output() fileList = new EventEmitter();
  @Output() modalStatus = new EventEmitter();

  constructor(
    public messagesService: MessagesService,
    public message: NzMessageService,
    private _lightbox: Lightbox,
  ) {
  }

  ngOnInit(): void {
    this.downloadModalVisible = false;
    this.subscription.add(this.messagesService.getMessage().subscribe(
      data => {
        if (data && data.name === this.messageType.WEBSOCKET_CONNECT_ERROR && !this.downloadModalVisible) {
          this.downloadModalVisible = true;
        }
      }
      ));
  }

  openHSC() {
    this.hscWebsocket = new HscWebsocket(this.messagesService);
    this.hscWebsocket.openSocket();
  }

  handleCloseHSCModal() {
    this.hscWebsocket.deleteFiles();
    this.hscWebsocket.closeSocket();
    this.modalStatus.emit('close');
  }

  doDeskew() {
    if (this.isDeskew) {
      this.hscWebsocket.unSetDeskew();
      this.isDeskew = !this.isDeskew;
    } else {
      this.hscWebsocket.setDeskew();
      this.isDeskew = !this.isDeskew;
    }
  }

  changeCamera() {
    if (this.isSubCamera) {
      this.hscWebsocket.useMainCamera();
      this.isSubCamera = !this.isSubCamera;
    } else {
      this.hscWebsocket.useSubCamera();
      this.isSubCamera = !this.isSubCamera;
    }
  }

  exportFiles() {
    if (_.filter(this.hscWebsocket.imgPathArray, o => o.fileType === null)?.length > 0) {
      return this.message.warning('请选择文件类型');
    }
    this.fileList.emit(this.hscWebsocket.imgPathArray);
    this.hscWebsocket.closeSocket();
    this.modalStatus.emit('close');
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  handleCloseDownloadModal() {
    this.downloadModalVisible = false;
  }


  openPreview(index) {
    const imgArr = this.hscWebsocket?.imgPathArray;
    let albums = [];
    for (const img of imgArr) {
      albums = [...albums, {
        src: img.src,
        caption: img.fileName || '',
        thumb: img.url
      }];
    }
    this._lightbox.open(albums, index, { showZoom: true, showRotate: true, centerVertically: true });
  }
}
